import { InformationTabTypes } from '@/data/enums'
import { IPopupTab } from '@/data/json/json'

export default class InformationWebsiteTab {
  public classes?: string[]
  public content!: string
  public image?: string | null
  public title?: string
  public sortOrder: number = 10
  public type?: InformationTabTypes = InformationTabTypes.Default
  public video?: string | null
  public module?: string | null

  constructor (tabData: IPopupTab) {
    const {
      afbeelding: image,
      html: content,
      template_tabel: type,
      titel: title,
      video,
      volgorde: sortOrder,
      module
    } = tabData
    switch (type) {
      case 'tpl_tab_afbeelding':
        this.type = InformationTabTypes.Image
        break
      case 'tpl_tab_tekst':
        this.type = InformationTabTypes.Text
        break
      case 'tpl_tab_video':
        this.type = InformationTabTypes.Video
        break
      case 'tpl_tab_module':
        this.type = InformationTabTypes.Custom
        break
      default:
        this.type = InformationTabTypes.Default
    }
    Object.assign(this, { content, image, sortOrder, title, video, module })
  }
}
